<template>
    <div>
        <v-dialog
            v-model="dialog"
            width="500"
        >
            <template v-slot:activator="{ on, attrs }">
                <Icon
                    name="fa/solid/trash-alt"
                    width="25px"
                    height="25px"
                    color="grey"
                    style="cursor: pointer;"
                    v-bind="attrs"
                    v-on="on"
                />
            </template>

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    <div
                        class="d-flex"
                        style="width: 100%;"
                    >
                        <div style="width: 90%;">
                            You are about to reset your Domain List
                        </div>
                        <div style="width: 10%;">
                            <div class="d-flex justify-end">
                                <Icon
                                    name="fa/solid/times-circle"
                                    width="35px"
                                    height="35px"
                                    color="white"
                                    style="cursor: pointer;"
                                    @click="dialog = false"
                                />
                            </div>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    Are you sure, you want to proceed?
                </v-card-text>
                <v-divider />
                <v-card-actions class="d-flex justify-end">
                    <div />
                    <div class="d-flex justify-end">
                        <v-btn
                            color="red"
                            style="color: white;"
                            text
                            @click="dialog = false"
                        >
                            Disagree
                        </v-btn>
                        <v-btn
                            color="green"
                            style="color: white;"
                            text
                            @click="$emit('clearLocalStorage'), dialog = false"
                        >
                            Agree
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Icon from '@wisol/icons'
import icons from '@wisol/icons/src/icons'
Icon.register(icons)

export default {
    components: {
        Icon
    },

    data () {
        return {
            dialog: false
        }
    }
}
</script>
